/**
 * HotX 套餐充值跨窗口回传桥。
 * 版本：V1.0；更新时间：2026-09-09 CST；父基线：15a7174ab7c0ae4e186433f093ac283da5bd1ea5。
 * 只传递“充值已确认”事实，不携带账号、金额、订单或凭据，也绝不自动重试扣款。
 */
export type RechargeNetwork = 'TRX' | 'BSC';

export interface RechargeSuccessEvent {
  type: 'HOTX_RECHARGE_SUCCESS';
  network: RechargeNetwork;
  occurredAt: number;
}

const CHANNEL_NAME = 'hotx:recharge-return:v1';

function isSuccessEvent(value: unknown): value is RechargeSuccessEvent {
  if (!value || typeof value !== 'object') return false;
  const event = value as Partial<RechargeSuccessEvent>;
  return event.type === 'HOTX_RECHARGE_SUCCESS'
    && (event.network === 'TRX' || event.network === 'BSC')
    && typeof event.occurredAt === 'number';
}

export function openRechargeWindow(network: RechargeNetwork) {
  const path = network === 'BSC' ? '/bsc-recharge' : '/trx-recharge';
  return window.open(`${path}?returnTo=domain-plan`, '_blank', 'noopener,noreferrer');
}

export function subscribeRechargeSuccess(callback: (event: RechargeSuccessEvent) => void) {
  if (typeof BroadcastChannel === 'undefined') return () => undefined;
  const channel = new BroadcastChannel(CHANNEL_NAME);
  channel.onmessage = event => {
    if (isSuccessEvent(event.data)) callback(event.data);
  };
  return () => channel.close();
}

export function announceRechargeSuccess(network: RechargeNetwork, occurredAt = Date.now()) {
  const event: RechargeSuccessEvent = { type: 'HOTX_RECHARGE_SUCCESS', network, occurredAt };
  if (typeof BroadcastChannel !== 'undefined') {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channel.postMessage(event);
    channel.close();
  }
  window.dispatchEvent(new CustomEvent('hotx:points-updated', { detail: event }));
}

export function isDomainPlanReturn(query: Record<string, unknown>) {
  return query.returnTo === 'domain-plan';
}

export async function completeRechargeReturn(options: {
  network: RechargeNetwork;
  query: Record<string, unknown>;
  showReturnPrompt: (message: string) => Promise<unknown>;
  closeRechargeTab: () => void;
  occurredAt?: number;
}) {
  announceRechargeSuccess(options.network, options.occurredAt);
  if (!isDomainPlanReturn(options.query)) return false;

  await options.showReturnPrompt('充值成功，积分已到账。请返回原窗口继续操作。');
  options.closeRechargeTab();
  return true;
}
